import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { DocumentCategoriesPage } from "src/components/views/documents/documentCategories/DocumentCategoriesPage.tsx";

export const Route = createFileRoute("/_authenticated/_shell/documents/documentCategories")({
	staticData: { title: i18n.t("document_categories"), legacyViewKey: "documentCategoriesPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <DocumentCategoriesPage />;
}
